import { render, staticRenderFns } from "./page010.vue?vue&type=template&id=7b9a8b46&scoped=true&"
import script from "./page010.vue?vue&type=script&lang=js&"
export * from "./page010.vue?vue&type=script&lang=js&"
import style0 from "./page010.vue?vue&type=style&index=0&id=7b9a8b46&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9a8b46",
  null
  
)

export default component.exports